var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-datetimepicker',{attrs:{"value":_vm.localValue,"datetime-formatter":_vm.formatDateTime,"rounded":"","placeholder":"placeholder","icon":"calendar-today","horizontal-time-picker":"","datetime":""},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }